import { EVENT } from '@/utils/event';
import request from '@/utils/request';

export function getSessionId(): Promise<string> {
  return new Promise<string>((resolve) => {
    const event = new CustomEvent(EVENT.GET_SESSION_ID, {
      detail: (sessionId: string) => {
        resolve(sessionId);
      }
    });

    dispatchEvent(event);
  });
}

// 试听
export function text2Speech(params: {
  text: string;
  pitch: number;
  rate: number;
  name: string;
  emotion: string;
  voicePlatformId: string;
}) {
  return request({
    url: `/rest/os/main/speech/text/2/speech`,
    method: 'post',
    data: params
  });
}
